import React from 'react';
import c from 'classnames';
import { useTranslation } from 'react-i18next';

import { SearchResultsInfinite } from '@uncinc/react-searchkit';

import { SearchAllContentHit } from '../types';
import Hit from './Hit';

const SearchAllContentResults: React.FC = () => {
  const { t } = useTranslation();

  const classNames = c('SearchAllContent__Results');

  return (
    <SearchResultsInfinite
      className={classNames}
      autoScroll
      showMoreButtonText={t('buttons.show_more')}
      renderItem={(hit: SearchAllContentHit) => <Hit hit={hit} />}
    />
  );
};

export default SearchAllContentResults;
